import { createReducer, on } from '@ngrx/store';
import { setFacebookConfig, setIsSidebar } from './system.actions';

export interface SystemState {
  isSidebar: boolean;
  facebook: {
    appId: string;
    configId: string;
  };
}

const initialState: SystemState = {
  isSidebar: false,
  facebook: {
    appId: '',
    configId: ''
  }
};

export const systemReducer = createReducer(
  initialState,
  on(setIsSidebar, (state, { isSidebar }) => ({
    ...state,
    isSidebar: isSidebar
  })),

  on(setFacebookConfig, (state, { appId, configId }) => ({
    ...state,
    facebook: {
      appId,
      configId
    }
  }))
);
